import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { FiChevronLeft } from 'react-icons/fi'

import backendApis from '../utils/backendApis.jsx'
import resize from '../utils/resize.jsx'
import { useNavigate } from 'react-router-dom'
import UserStore from '../stores/UserStore.jsx'

/**
 * 올툰 이벤트 페이지 (id기반 이벤트 정보 조회)
 */
const AltoonEventListPage = observer(() => {
  const navigate = useNavigate()
  const pathMapper = {
    '/altoon-reader': '/toon-reader',
    '/altoon-novel-reader': '/novel-detail',
    '/altoon-event-page': '/event',
    '/altoon-main-event-page': '/main-event',
  }

  const [bannerData, setBannerData] = useState()

  useEffect(() => {
    const fetchData = async () => {
      const bannerData = await backendApis.loadBannerData()
      if (bannerData?.status === 200) {
        const filteredBannerData = bannerData?.data?.filter(
          (banner) =>
            !banner?.bannerType && banner?.itemId?.toString() !== '65e0160e3401440ed9cecde3'
        )
        setBannerData(filteredBannerData)
      }
    }
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({
        type: 'allowiPhoneGesture',
        boolean: false,
      })
    )

    fetchData()
    UserStore.setIsLoaded(true)
  }, [])

  const handleBannerClick = (data, index) => {
    // URL에서 pathname과 쿼리 파라미터 분리
    const queryString = data?.pathname?.split('?')
    const searchParams = new URLSearchParams(queryString[1])
    const eventId = searchParams.get('eventId') || ''
    const itemId = searchParams.get('itemId') || ''

    if (queryString[0] === '/altoon-novel-reader') {
      const novelId = data?.state?.novelId
      navigate(`/novel-detail/${novelId}`)
    } else if (queryString[0] === '/altoon-reader') {
      navigate(`/toon-reader/${data?.state?.chapterInfo?._id}`, {
        state: {
          chapterInfo: data?.state?.chapterInfo,
          toonInfo: data?.state?.toonInfo,
          episode: data?.state?.episode,
          rentPeriod: data?.state?.rentPeriod,
        },
      })
    } else if (queryString[0] === '/altoon-event-page') {
      navigate(`/event/${eventId}`)
    } else {
      navigate(pathMapper[queryString[0]], {
        state: {
          ...data?.state,
        },
        ...(eventId && { eventId }),
        ...(itemId && { itemId }),
      })
    }
  }

  const HeaderComponent = () => {
    return (
      <section className="fixed top-0 w-full bg-white z-10 py-2 flex flex-row items-center justify-between overflow-hidden font-bold">
        <button
          type="button"
          aria-label="back"
          className="mx-2 p-2 whitespace-nowrap"
          onClick={async () => {
            navigate(-1)
          }}
        >
          <FiChevronLeft className="w-8 h-8 stroke-[0.2vw]" />
        </button>
        <div className="text-[4.2vw] py-2 whitespace-nowrap">이벤트</div>
        <div className="w-[16vw]" />
      </section>
    )
  }

  const MainImageSection = () => {
    return (
      <div>
        {bannerData?.map((banner, index) => {
          return (
            <button
              key={index || Math.random()}
              type="button"
              onClick={() => {
                handleBannerClick(banner?.navigateTo, index)
              }}
            >
              <img
                className="w-full h-auto py-[2vw]"
                src={resize(banner?.imageUri, 1230, 825)}
                alt="banner"
              />
            </button>
          )
        })}
      </div>
    )
  }

  return (
    <div>
      <HeaderComponent />
      <div className="pt-[10vw]">
        <MainImageSection />
      </div>
    </div>
  )
})

export default AltoonEventListPage
